interface CopyToClipboardOptions {
  message: string
  onSuccess?: () => void
  onError?: (error: Error) => void
}

export const copyToClipboard = async ({ message, onSuccess, onError }: CopyToClipboardOptions) => {
  try {
    await navigator.clipboard.writeText(message)
    onSuccess?.()
  } catch (error) {
    onError?.(error instanceof Error ? error : new Error(String(error)))
  }
}
